import React from "react";
import {Logo} from "../icons/Logo";


function PoweredBy() {
    return (
        <div className="flex-row flex justify-center powered-by">
            <span>powered by</span>
            <div className="flex flex-row justify-center items-center ml-2">
                <Logo height={12} width={12}/>
                <div className="desc2 ml-1">URTENTIC</div>
            </div>
        </div>
    );
}

export default PoweredBy;
